<template>
  <el-dialog title="Preis aktualisieren" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <fg-input label="Preis"
            type="text"
            :value="price"
            @input="price = $event"
            :error="valErrors['price'] ? valErrors['price'][0] : null"
          />
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary"
            >
              Aktualisieren
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import priceWatcher from 'src/pages/Products/price-watcher'

export default {
  props: ['show', 'valErrors'],
  components: { [Dialog.name]: Dialog },
  mixins: [priceWatcher],
  data () {
    return {
      productPrice: ''
    }
  },
  computed: {
    canSubmit () {
      return this.productPrice
    }
  },
  methods: {
    getPrice () {
      return this.productPrice
    },
    setPrice (price) {
      this.productPrice = price
    },
    submit () {
      this.$emit('updatePrice', this.productPrice)
    },
    close () {
      this.productPrice = ''
      this.$emit('close')
    }
  }
}
</script>

<style>
</style>
